module.exports = __webpack_public_path__ + "img/badge-score.f88bd13c.svg";